import { render, staticRenderFns } from "./CustomDisplayElementExpandMember.vue?vue&type=template&id=2a2c05a1&scoped=true&lang=html"
import script from "./CustomDisplayElementExpandMember.vue?vue&type=script&lang=js"
export * from "./CustomDisplayElementExpandMember.vue?vue&type=script&lang=js"
import style0 from "./CustomDisplayElementExpandMember.vue?vue&type=style&index=0&id=2a2c05a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c05a1",
  null
  
)

export default component.exports